export const paramsToQuery = (params: Record<string, string | number | Date>): string => {
  const list = Object.entries(params).map(([k, v]) => `${k}=${encodeURIComponent(`${v}`)}`)
  return list.join('&')
}
